import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Menu,
  X,
  User,
  Bell,
  LayoutDashboard,
  ChevronDown,
} from "lucide-react";
import { profileService } from "../services/profileService";
import logo from "../assets/images/logo.svg";
import { getUserIdFromToken } from "../utils/tokenUtils";
// import Banner from "../components/Banner";

const CommunityHeader = ({ isAuthenticated }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);
  const [userImage, setUserImage] = useState("");
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setProfileDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Fetch user profile image when authenticated
  useEffect(() => {
    const fetchUserImage = async () => {
      if (isAuthenticated) {
        const token = localStorage.getItem("token");
        if (token) {
          try {
            const userId = getUserIdFromToken(token);
            if (userId) {
              const response = await profileService.getUserImage(userId, token);
              const imageUrl = URL.createObjectURL(response.data);
              setUserImage(imageUrl);
            }
          } catch (error) {
            console.error("Error fetching user image:", error);
            // Keep default image on error
          }
        }
      }
    };

    fetchUserImage();
  }, [isAuthenticated]);

  return (
    <>
    {/* <Banner /> */}
    <header className="bg-white shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 flex justify-between items-center">
        <Link to="/" className="text-2xl font-bold text-indigo-600">
          <img src={logo} alt="Ajo Logo" className="mx-auto w-24 h-auto" />
        </Link>

        {/* Desktop Menu */}
        <nav className="hidden md:flex space-x-6 items-center">
          {!isAuthenticated ? (
            <Link
              to="/login"
              className="text-sm px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
            >
              Login
            </Link>
          ) : (
            <div className="relative" ref={dropdownRef}>
              <button
                onClick={() => setProfileDropdownOpen(!profileDropdownOpen)}
                className="flex items-center space-x-1 p-2 rounded-full hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500"
              >
                {/* URL validated to only allow data:image or https:// sources */}
                {/* snyk-disable-next-line javascript/xss */}
                <img
                  src={
                    userImage?.startsWith('data:image') || userImage?.startsWith('https://') 
                      ? userImage 
                      : `https://api.dicebear.com/6.x/initials/svg?seed=ajo`
                  }
                  alt="Profile"
                  className="w-8 h-8 rounded-full object-cover"
                />
                <ChevronDown
                  className={`w-4 h-4 transition-transform ${
                    profileDropdownOpen ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Profile Dropdown */}
              {profileDropdownOpen && (
                <div className="absolute right-0 mt-2 w-48 bg-white rounded-md shadow-lg py-1 z-50 border border-gray-200">
                  <Link
                    to="/app/dashboard"
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    <LayoutDashboard className="w-4 h-4 mr-3" />
                    Dashboard
                  </Link>
                  <Link
                    to="/app/notifications"
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    <Bell className="w-4 h-4 mr-3" />
                    Notifications
                  </Link>
                  <Link
                    to="/app/profile"
                    className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                    onClick={() => setProfileDropdownOpen(false)}
                  >
                    <User className="w-4 h-4 mr-3" />
                    Profile
                  </Link>
                </div>
              )}
            </div>
          )}
        </nav>

        {/* Mobile Menu Button */}
        <button
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          className="md:hidden text-gray-700"
        >
          {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Dropdown Menu */}
      {mobileMenuOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2">
          {!isAuthenticated ? (
            <Link
              to="/login"
              className="block text-sm px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              Login
            </Link>
          ) : (
            <>
              <Link
                to="/app/dashboard"
                className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <LayoutDashboard className="w-4 h-4" />
                <span>Dashboard</span>
              </Link>
              <Link
                to="/app/notifications"
                className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <Bell className="w-4 h-4" />
                <span>Notifications</span>
              </Link>
              <Link
                to="/app/profile"
                className="flex items-center space-x-2 text-gray-700 hover:text-indigo-600 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                <User className="w-4 h-4" />
                <span>Profile</span>
              </Link>
            </>
          )}
        </div>
      )}
    </header>
    </>
  );
};

export default CommunityHeader;
